import React, { useState, useEffect, useRef } from 'react';
import api from '../../services/api';
import cdrFilesService from '../../services/cdrFilesService';
import { Link } from 'react-router-dom';
import useRoles from '../../hooks/useRoles';
import MultiSelectDropdown from '../../components/MultiSelectDropdown';

const ItemList = ({ isAuthenticated }) => {
  const { hasRole } = useRoles();
  const [items, setItems] = useState([]);
  const [cdrFilesServerAvailable, setCdrFilesServerAvailable] = useState(false);
  const [cdrfiles, setCdrfiles] = useState([]);
  //const [imageUrls, setImageUrls] = useState({}); // Состояние для хранения URL изображений
  const [categories, setCategories] = useState([]);
  const [materials, setMaterials] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  const [filters, setFilters] = useState({
    namePart: '',
    categoryIds: [],   // теперь массив
    materialIds: [],   // теперь массив
    sortParam: 'time_desc',
    hasArticle: null,
    hasCdrFile: null,
    hasVarnish: null,
    hasQrCodes: null,
    pageSize: 6,
    pageNumber: 1,
  });


  const articleCheckboxRef = useRef(null);
  const cdrFileCheckboxRef = useRef(null);
  const varnishCheckboxRef = useRef(null);
  const qrCodesCheckboxRef = useRef(null);
  
  const fetchItems = async () => {
    try {
      const itemResp = await api.post('/items/filter', filters);
      setItems(itemResp.data.elements); // Предполагаем, что сервер возвращает items и totalCount
      setTotalCount(itemResp.data.totalCount);
    } catch (err) {
      console.error(err);
    }
  };

  // Функция для загрузки cdrfile по itemId
  const fetchCdrfiles = async (items) => {
    if (!items) return null;
    try {
      const itemIds = items.map(item => item.id);
      const payload = { itemIds: itemIds};
      const response = await cdrFilesService.post(`/cdrfiles`, payload);
      return response.data;
    } catch (err) {
      console.error('Error loading image:', err);
      return null;
    }
  };

  const fetchCategoriesAndMaterials = async () => {
    try {
      const [categoriesRes, materialsRes] = await Promise.all([
        api.get('/categories'), // Загрузка категорий
        api.get('/materials'), // Загрузка материалов
      ]);
      setCategories(categoriesRes.data);
      setMaterials(materialsRes.data);
    } catch (err) {
      console.error(err);
    }
  };

  // Функция для загрузки изображения по imageId
  // const fetchImage = async (imageId) => {
  //   if (!imageId) return null;
  //   try {
  //     const response = await cdrFilesService.get(`/PngFiles/${imageId}`, {
  //       responseType: 'blob',
  //     });
  //     return URL.createObjectURL(response.data);
  //   } catch (err) {
  //     console.error('Error loading image:', err);
  //     return null;
  //   }
  // };

  const loadCdrfiles = async () => {
    if (cdrFilesServerAvailable && items.length > 0){
      // Загружаем изображения для новых предметов
      var cdrfilesResp = await fetchCdrfiles(items);
      if (cdrfilesResp != null && cdrfilesResp.elements.length > 0)
        initCdrfiles(cdrfilesResp.elements);
    }
  };

  // Загрузка изображений для всех предметов
  const initCdrfiles = async (cdrfiles) => {
    const itemIds_cdrfiles = {};
    for (const cdrfile of cdrfiles) {
      if (cdrfile) {
        itemIds_cdrfiles[cdrfile.itemId] = cdrfile;
      }
    }
    setCdrfiles(itemIds_cdrfiles);
  };

  useEffect(() => {
      const checkCdrFilesServerAvailable = async () => {
        try {
          const response = await cdrFilesService.health();
          setCdrFilesServerAvailable(true);
        } catch (err) {
          console.error(err);
          setCdrFilesServerAvailable(false);
        }
      };
      checkCdrFilesServerAvailable();
    }, []);

  // Загрузка списка категорий и материалов
  useEffect(() => {
    fetchCategoriesAndMaterials();
  }, []);

  // Загрузка элементов с учетом фильтров
  useEffect(() => {
    fetchItems();
  }, [filters]);

  // Загрузка списка cdrfiles
  useEffect(() => {
    loadCdrfiles();
  }, [items, cdrFilesServerAvailable]);

  // // Очистка URL объектов при размонтировании компонента
  // useEffect(() => {
  //   return () => {
  //     Object.values(imageUrls).forEach(url => {
  //       if (url) URL.revokeObjectURL(url);
  //     });
  //   };
  // }, [imageUrls]);

  // Обработка изменения фильтров
  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    setFilters({ ...filters, [name]: value, pageNumber: 1 }); // Сброс номера страницы при изменении фильтра
  };

  // Обработка изменения страницы
  const handlePageChange = (newPageNumber) => {
    setFilters({ ...filters, pageNumber: newPageNumber });
  };

  useEffect(() => {
    setCheckboxIndeterminate(articleCheckboxRef, filters.hasArticle);
    setCheckboxIndeterminate(cdrFileCheckboxRef, filters.hasCdrFile);
    setCheckboxIndeterminate(varnishCheckboxRef, filters.hasVarnish);
    setCheckboxIndeterminate(qrCodesCheckboxRef, filters.hasQrCodes);
  }, [filters.hasArticle, filters.hasCdrFile, filters.hasVarnish, filters.hasQrCodes]);

  const setCheckboxIndeterminate = (ref, value) => {
    if (ref.current) {
      ref.current.indeterminate = value === null;
    }
  };

  const handleCheckboxChange = (name, currentValue) => {
    let newValue;
    if (currentValue === null) newValue = true;
    else if (currentValue === true) newValue = false;
    else newValue = null;
    setFilters({ ...filters, [name]: newValue, pageNumber: 1 });
  };

  // Удаление элемента
  const handleDelete = async (id) => {
    try {
      await api.delete(`/items/${id}`);
      setItems(items.filter((item) => item.id !== id)); // Удаляем элемент из списка
      // Очищаем URL изображения при удалении
      // if (imageUrls[id]) {
      //   URL.revokeObjectURL(imageUrls[id]);
      //   const newUrls = { ...imageUrls };
      //   delete newUrls[id];
      //   setImageUrls(newUrls);
      // }
    } catch (err) {
      console.error(err);
    }
  };

  const getPageNumbers = (currentPage, totalPages) => {
    const pages = [];
    const delta = 2; // сколько страниц показывать рядом с текущей

    const range = [];
    for (let i = Math.max(2, currentPage - delta); i <= Math.min(totalPages - 1, currentPage + delta); i++) {
      range.push(i);
    }

    if (currentPage - delta > 2) {
      range.unshift('...');
    }
    if (currentPage + delta < totalPages - 1) {
      range.push('...');
    }

    range.unshift(1);
    if (totalPages > 1) {
      range.push(totalPages);
    }

    return range;
  };

  const totalPages = Math.ceil(totalCount / filters.pageSize);

  return (
    <div className="container mt-4">
      {localStorage.getItem("access_token") !== undefined && (
        <div>
          <h1>Товары</h1>
          <div className="d-flex justify-content-between align-items-center mb-3">
            {hasRole('CreateItem') && (
              <Link to="/items/new" className="btn btn-primary">
                Создать новый товар
              </Link>
            )}
          </div>

          {cdrFilesServerAvailable === false && (
            <div className="text-danger my-3">Сервер cdr файлов недоступен</div>
          )}

          <div className="row mb-3">
            <div className="col-md-3">
              <input
                type="text"
                className="form-control"
                name="namePart"
                placeholder="Поиск по названию или артикулу"
                value={filters.namePart}
                onChange={handleFilterChange}
              />
            </div>
            <div className="col-md-3">
              <MultiSelectDropdown
                options={categories}
                selectedIds={filters.categoryIds}
                onChange={(newIds) => setFilters({ ...filters, categoryIds: newIds, pageNumber: 1 })}
                placeholderAll="Все категории"
                placeholderOne="Категория"
                placeholderMany="категорий"
              />
            </div>
            <div className="col-md-3">
              <MultiSelectDropdown
                options={materials}
                selectedIds={filters.materialIds}
                onChange={(newIds) => setFilters({ ...filters, materialIds: newIds, pageNumber: 1 })}
                placeholderAll="Все материалы"
                placeholderOne="Материал"
                placeholderMany="материалов"
              />
            </div>
            <div className="col-md-3">
              <select
                className="form-control"
                name="sortParam"
                value={filters.sortParam}
                onChange={handleFilterChange}
              >
                <option value="time_desc">Время (сначала новые)</option>
                <option value="time_asc">Время (сначала старые)</option>
                <option value="size_desc">Размер (по убыванию)</option>
                <option value="size_asc">Размер (по возрастанию)</option>
                {/* <option value="name_desc">Название (А-Я)</option>
                <option value="name_asc">Название (Я-А)</option> */}
              </select>
            </div>
            <div className="col-md-2">
              <input
                class="form-check-input"
                type="checkbox"
                ref={articleCheckboxRef}
                checked={filters.hasArticle || false}
                onChange={() => handleCheckboxChange('hasArticle', filters.hasArticle)}
              />{' '}
              Есть артикул
            </div>

            <div className="col-md-2">
              <input
                class="form-check-input"
                type="checkbox"
                ref={cdrFileCheckboxRef}
                checked={filters.hasCdrFile || false}
                onChange={() => handleCheckboxChange('hasCdrFile', filters.hasCdrFile)}
              />{' '}
              Есть макет
            </div>

            <div className="col-md-2">
              <input
                className="form-check-input"
                type="checkbox"
                ref={varnishCheckboxRef}
                checked={filters.hasVarnish || false}
                onChange={() => handleCheckboxChange('hasVarnish', filters.hasVarnish)}
              />{' '}
              Есть лак
            </div>

            <div className="col-md-2">
              <input
                className="form-check-input"
                type="checkbox"
                ref={qrCodesCheckboxRef}
                checked={filters.hasQrCodes || false}
                onChange={() => handleCheckboxChange('hasQrCodes', filters.hasQrCodes)}
              />{' '}
              Есть QR-коды
            </div>
          </div>

          {/* Таблица с элементами */}
          <table className="table table-striped">
            <thead>
              <tr>
                <th>Изображение</th>
                <th>Название</th>
                <th>Категория</th>
                <th>Материал</th>
                <th>Размер (ШxВxГ см)</th>
                <th>Время создания</th>
              </tr>
            </thead>
            <tbody>
              {items.map((item) => {
                const cdrFile = cdrfiles[item.id];

                const varnishBadge =  cdrFile && cdrFile.varnishPercent > 0 ? (
                  <span className="badge bg-warning text-dark ms-1">
                    {cdrFile.varnishPercent}% лака
                  </span>
                ) : null;

                const whiteBadge =  cdrFile && cdrFile.whitePercent > 0 ? (
                  <span className="badge bg-light text-dark ms-1">
                    {cdrFile.whitePercent}% белого
                  </span>
                ) : null;

                const qrBadge = cdrFile && cdrFile.qrCodesCount > 0 ? (
                  <span className="badge bg-success ms-1">
                    {cdrFile.qrCodesCount} QR-кодов
                  </span>
                ) : null;

                return (
                  <tr key={item.id}>
                    <td>
                      {cdrFile ? (
                        <img
                          src={cdrFilesService.getCdrfilePreview(cdrFile.imageId)}
                          alt={item.name}
                          style={{ width: "150px", height: "150px", objectFit: "contain" }}
                        />
                      ) : (
                        <div style={{ width: "150px", height: "150px", backgroundColor: "#eee" }} />
                      )}
                    </td>
                    <td>
                      <Link to={`/items/${item.id}`}>
                        {item.name}
                      </Link>
                      <p>{item.article}</p>
                      <div className="d-flex flex-wrap">
                        {varnishBadge}
                        {whiteBadge}
                        {qrBadge}
                      </div>
                    </td>
                    <td>{item.category.name}</td>
                    <td>{item.material.name}</td>
                    <td>{item.widthInCm}x{item.heightInCm}x{item.depthInCm}</td>
                    <td>{new Date(item.creationTime).toLocaleString()} {item.createdBy}</td>
                  </tr>
                );
              })}
            </tbody>
          </table>

          {/* Пагинация */}
          <nav>
            <ul className="pagination">
              <li className={`page-item ${filters.pageNumber === 1 ? 'disabled' : ''}`}>
                <button
                  className="page-link"
                  onClick={() => handlePageChange(filters.pageNumber - 1)}
                  disabled={filters.pageNumber === 1}
                >
                  Назад
                </button>
              </li>

              {getPageNumbers(filters.pageNumber, totalPages).map((page, index) => (
                <li
                  key={index}
                  className={`page-item ${page === filters.pageNumber ? 'active' : ''} ${page === '...' ? 'disabled' : ''}`}
                >
                  {page === '...' ? (
                    <span className="page-link">...</span>
                  ) : (
                    <button
                      className="page-link"
                      onClick={() => handlePageChange(page)}
                    >
                      {page}
                    </button>
                  )}
                </li>
              ))}

              <li className={`page-item ${filters.pageNumber === totalPages ? 'disabled' : ''}`}>
                <button
                  className="page-link"
                  onClick={() => handlePageChange(filters.pageNumber + 1)}
                  disabled={filters.pageNumber === totalPages}
                >
                  Вперед
                </button>
              </li>
            </ul>
          </nav>
        </div>
      )}

      
    </div>
  );
};

export default ItemList;